import React from 'react';
import { ChevronRight } from 'lucide-react';
import './Breadcrumb.css';
import { getFullStateName } from '../../constants/locations';

const Breadcrumb = ({ selectedLocation, onTypeClick, selectedView, isHistorical, activeTab }) => {
  if (!selectedLocation?.info?.type) return null;

  const { type, name } = selectedLocation.info;
  const formattedType = type.charAt(0).toUpperCase() + type.slice(1);
  
  if (type === 'county' && name.includes(', ')) {
    const parts = name.split(', ');
    const county = parts.slice(0, -1).join(', ');
    const state = parts[parts.length - 1];
    
    return (
      <div className={`table-breadcrumb ${isHistorical && selectedView === 'table' && activeTab !== 'reports' ? 'historical' : ''}`}>
        <button 
          className="breadcrumb-link"
          onClick={() => onTypeClick({ type: 'county' })}
        >
          Counties
        </button>
        <ChevronRight size={14} />
        <button 
          className="breadcrumb-link"
          onClick={() => onTypeClick({ 
            type: 'county', 
            state: state
          })}
        >
          {state}
        </button>
        <ChevronRight size={14} />
        <span>{county}</span>
      </div>
    );
  }

  if (type === 'city' && name.includes(', ')) {
    const parts = name.split(', ');
    const city = parts.slice(0, -1).join(', ');
    const state = parts[parts.length - 1];
    
    return (
      <div className={`table-breadcrumb ${isHistorical && selectedView === 'table' && activeTab !== 'reports' ? 'historical' : ''}`}>
        <button 
          className="breadcrumb-link"
          onClick={() => onTypeClick({ type: 'city' })}
        >
          Cities
        </button>
        <ChevronRight size={14} />
        <button 
          className="breadcrumb-link"
          onClick={() => onTypeClick({ 
            type: 'city', 
            state: state
          })}
        >
          {state}
        </button>
        <ChevronRight size={14} />
        <span>{city}</span>
      </div>
    );
  }

  if (type === 'county' && name.startsWith('All ') && name !== 'All Counties') {
    const stateMatch = name.match(/All\s+([A-Z]{2})\s+Counties/);
    const stateAbbr = stateMatch ? stateMatch[1] : '';
    const fullStateName = getFullStateName(stateAbbr);
    
    return (
      <div className={`table-breadcrumb ${isHistorical && selectedView === 'table' && activeTab !== 'reports' ? 'historical' : ''}`}>
        <button 
          className="breadcrumb-link"
          onClick={() => onTypeClick({ type: 'county' })}
        >
          Counties
        </button>
        <ChevronRight size={14} />
        <span>{fullStateName}</span>
      </div>
    );
  }

  if (type === 'city' && name.startsWith('All ') && name !== 'All Cities') {
    const stateMatch = name.match(/All\s+([A-Z]{2})\s+Cities/);
    const stateAbbr = stateMatch ? stateMatch[1] : '';
    const fullStateName = getFullStateName(stateAbbr);
    
    return (
      <div className={`table-breadcrumb ${isHistorical && selectedView === 'table' && activeTab !== 'reports' ? 'historical' : ''}`}>
        <button 
          className="breadcrumb-link"
          onClick={() => onTypeClick({ type: 'city' })}
        >
          Cities
        </button>
        <ChevronRight size={14} />
        <span>{fullStateName}</span>
      </div>
    );
  }
  
  if (name === 'All Counties') {
    return (
      <div className={`table-breadcrumb ${isHistorical && selectedView === 'table' && activeTab !== 'reports' ? 'historical' : ''}`}>
        <span>Counties</span>
      </div>
    );
  }

  if (name === 'All Cities') {
    return (
      <div className={`table-breadcrumb ${isHistorical && selectedView === 'table' && activeTab !== 'reports' ? 'historical' : ''}`}>
        <span>Cities</span>
      </div>
    );
  }

  return (
    <div className={`table-breadcrumb ${isHistorical && selectedView === 'table' && activeTab !== 'reports' ? 'historical' : ''}`}>
      <button 
        className="breadcrumb-link"
        onClick={() => onTypeClick({ type })}
      >
        {formattedType}s
      </button>
      <ChevronRight size={14} />
      <span>{name}</span>
    </div>
  );
};

export default Breadcrumb;